/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { VehicleNotFitV2 } from './VehicleNotFitV2';
import type { ParentSkuCardProps } from '../../ParentSkuCard';

type Props = {
  fittingPartsURL: string;
  parentSkuCardProps: ParentSkuCardProps;
  onVehicleDoesNotFitCtaOnClick: () => void;
};

export function VehicleNotFit(props: Props) {
  return <VehicleNotFitV2 {...props} />;
}
